<div class="container">

	<div id="carousel-news" class="row">
		<div class="col-lg-8 col-xl-9 pr-lg-0">
			<div id="carousel-news-indicators" class="carousel slide" data-ride="carousel">
				<ol class="carousel-indicators d-lg-none">
					<li *ngFor="let news of newsList;" 
					 (click)="setSelectedNewsId(news)"
					[ngClass]="news.id === selectedNewsId ? 'active' : ''"></li>
				</ol>
				<div>
					<div *ngFor="let news of newsList" [ngClass]="news.id === selectedNewsId ? 'carousel-item active' : 'carousel-item'">
							<div class="container-fluid mt-3" *ngIf="news.type == 1">
								<div class="card-header">
								  <div class=" table-header d-flex justify-content-center">
									<h4 class="table-title">
									  {{news.title}}
									</h4>
								  </div>
								</div>
								<div class="table-responsive">
								  <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
										 data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }'
										 style="table-layout:fixed">
									<thead class="thead-dark">
									<tr>
									  <th *ngFor="let header of getHeaders(news)">{{header}}</th>
									</tr>
									</thead>
							  
									<tbody *ngFor="let record of getTableRecords(news)">
									<tr>
									  <td *ngFor="let value of record.recordValues">{{value}}</td>
									</tr>
									<tr>
									  <td [colSpan]="getHeaders(news).length" class="last">
										<strong>Come funziona:</strong>
										<span [innerHTML]="record.description"></span>
									  </td>
									</tr>
									</tbody>
								  </table>
								</div>
							  </div>
						<div *ngIf="news.type == 2">
							<img id="slideimage" class="d-block w-100" [src]="getCompleteImageUrl(news)" (click)="goToArticle(news)" alt="slide">
							<div class="slide-text">
								<h3><a (click)="goToArticle(news)">{{news.title}}</a></h3>
								<p class="d-none d-sm-block" [innerHTML]="newsTextPreview(news)"></p>
							</div>
						</div>
					</div>
				</div>
				<a class="carousel-control-prev d-lg-none" 
				(click)="goToPreviousSlide()">
					<span class="carousel-control-prev-icon" aria-hidden="true"></span>
					<span class="sr-only">Previous</span>
				</a>
				<a class="carousel-control-next d-lg-none"
				(click)="goToNextSlide()">
					<span class="carousel-control-next-icon" aria-hidden="true"></span>
					<span class="sr-only">Next</span>
				</a>
			</div>
		</div>
		<div class="d-none d-lg-block col-lg-4 col-xl-3 pl-0">
			<div id="carousel-news-title-list">
				<!-- set class="active" on div with ngClass... -->
				<div (click)="setSelectedNewsId(news)" *ngFor="let news of newsList;" [ngClass]="news.id === selectedNewsId ? 'active' : ''">{{news.title}}</div>
			</div>
		</div>
	</div>



</div>
